import React, { useContext, useState, useEffect, useCallback } from "react"
import { Grid, makeStyles } from "@material-ui/core"
import { DEFAULT_BOX_SHADOW } from "App/constants"
import ModalListKunjungan from "App/Component/layout/Penjualan/InputPenjualan/ui/Perhitungan/Modal/ModalMuat/ModalListKunjungan"
import { RESET_STATE_INPUT_TAGIHAN, urlGetKunjungan } from ".."
import { MasterButton } from "App/Component/ui"
import { Person } from "@material-ui/icons"
import { FormContext } from "../../context/FormContext"
import { formatNumber, isNull } from "App/utils/helpers"

const useStyles = makeStyles({
  titleTagihan: {
    fontWeight: 600,
    fontSize: 16,
  },
  rootTagihan: {
    padding: "1rem",
    boxShadow: DEFAULT_BOX_SHADOW,
    borderRadius: "8px",
  },
  tableTagihan: {
    marginTop: "1rem",
    lineHeight: "1.75rem",
  },
})

function TabTagihan({ setNewData }) {
  const [showModalListKunjungan, setShowModalListKunjungan] = useState(false)
  const { formData, setFormData, setDataPaket } = useContext(FormContext)
  const handleClickSelect = (row) => {
    setFormData({
      ...RESET_STATE_INPUT_TAGIHAN,
      no_sep: row.no_sep,
      company_name: row.company_name,
      company_id: row.company_id,
      kunjungan_id: row.id,
      rm_name: row.isexternalrm ? row.rm_name_external : row.rm_name,
      rm_id: row.patients_id,
      asuransi_id: row.insurance_id,
      asuransi_no: row.insurance_no,
      asuransi: row.insurance_name,
      rm_umur: row.umur,
      rm_tanggal_lahir: row.rm_tanggal_lahir,
      no_npwp: row?.rm_npwp,
      jenis_layanan_id: row.jenis_layanan_id,
      jenis_layanan_name: row.layanan_name,
      kelas_id: row.kelaskunjungan_id === 0 ? null : row.kelaskunjungan_id,
      kelas_name: isNull(row.kelaskunjungan_name)
        ? "Pilih Kelas"
        : row.kelaskunjungan_name,
    })
    setDataPaket([])
    setShowModalListKunjungan(false)
  }
  const classes = useStyles()

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F2") {
      setShowModalListKunjungan(true)
    }
  }, [])

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [handleKeyPress])

  return (
    <>
      {showModalListKunjungan && (
        <ModalListKunjungan
          setShowModal={setShowModalListKunjungan}
          handleClickSelect={handleClickSelect}
          url={urlGetKunjungan}
          type="custom"
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "1rem",
        }}
      >
        <MasterButton
          type={"button"}
          color="green"
          outline={true}
          name="CARI KUNJUNGAN"
          onClick={() => setShowModalListKunjungan(!showModalListKunjungan)}
          size="sm"
          withIcon={true}
          icon={<Person width="17px" height="17px" />}
        />
      </div>

      <Grid container spacing={2}>
        <Grid item sm={formData.is_paket ? 6 : 6} md={4} lg={4}>
          <TotalTagihan classes={classes} formData={formData} />
        </Grid>
        {/* {
          formData.is_paket ? (
            <>
            <Grid item sm={6} md={6}>
            <TotalPaket classes={classes} formData={formData} />
            </Grid>

            </>
          ) : (<></>)
        } */}
        <Grid item sm={formData.is_paket ? 6 : 6} md={4} lg={4}>
          <Pembayaran classes={classes} formData={formData} />
        </Grid>
        <Grid item sm={formData.is_paket ? 6 : 12} md={4} lg={4}>
          <Ditanggung classes={classes} formData={formData} />
        </Grid>
      </Grid>
    </>
  )
}

const TotalTagihan = ({ classes, formData }) => {
  const subTotal = formData.tagihan?.jumlah - formData.tagihan?.potongan
  const tax = (formData.tagihan?.tax / subTotal) * 100
  // const total = subTotal + tax;
  const taxPercent = isNaN(tax) ? 0 : tax.toFixed(2)
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}>
        {formData.is_paket ? "Total Tagihan Paket" : "Total Tagihan"}{" "}
      </p>
      <table width={"100%"} className={classes.tableTagihan}>
        <tbody>
          {formData.is_paket ? (
            <>
              <tr>
                <td width={"60%"}>Total Paket</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.totalPaket?.total_paket)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
            </>
          ) : (
            <></>
          )}

          <tr>
            <td width={"60%"}>Total Penjualan</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">{formatNumber(formData.tagihan?.jumlah)}</td>
          </tr>
          <tr>
            <td width={"60%"}>Potongan/Tax({formatNumber(taxPercent)}%)</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.tagihan?.potongan)} /{" "}
              {formatNumber(formData.tagihan?.tax)}
            </td>
          </tr>
          {formData.is_paket ? (
            <>
              <tr>
                <td></td>
                <td
                  colSpan={2}
                  style={{
                    borderBottom: "1px dashed black",
                    padding: "0.5rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td width={"60%"}>Total Tagihan</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.tagihan.total_tagihan)}
                </td>
              </tr>
            </>
          ) : (
            <></>
          )}

          {formData.is_paket ? (
            <></>
          ) : (
            <>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td></td>
                <td
                  colSpan={2}
                  style={{
                    borderBottom: "1px dashed black",
                    padding: "0.5rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td width={"60%"}>Total Tagihan</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.tagihan.total_tagihan)}
                </td>
              </tr>
            </>
          )}

          {formData.is_paket ? (
            <>
              <tr>
                <td width={"60%"}>Selisih Nilai Paket</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.totalPaket?.jumlah_selisih)}
                </td>
              </tr>
            </>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  )
}

const Pembayaran = ({ classes, formData }) => {
  const sisa =
    formData.pembayaran?.total_tagihan - formData.pembayaran?.total_pembayaran
  const selisihTagihan = formData.ditanggung.jumlah_selisih

  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}> Pembayaran </p>
      <table width={"100%"} className={classes.tableTagihan}>
        <tbody>
          {formData.is_paket ? (
            <>
              <tr>
                <td width={"60%"}>Total Paket</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.totalPaket?.total_paket)}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td width={"60%"}>Total Tagihan</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(formData.pembayaran?.total_tagihan)}
                </td>
              </tr>
            </>
          )}

          <tr>
            <td width={"60%"}>Total Pembayaran</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.pembayaran?.total_pembayaran)}
            </td>
          </tr>

          <tr>
            <td width={"60%"}>Selisih Ditanggung</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {selisihTagihan < 0
                ? `(${formatNumber(Math.abs(selisihTagihan))})`
                : `${formatNumber(selisihTagihan)}`}
            </td>
          </tr>
          {formData.is_paket ? (
            <>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
            </>
          ) : (
            <></>
          )}
          <tr>
            <td></td>
            <td
              colSpan={2}
              style={{
                borderBottom: "1px dashed black",
                padding: "0.5rem 0",
              }}
            ></td>
          </tr>

          <tr>
            <td width={"60%"}>Sisa Pembayaran</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">{formatNumber(sisa + selisihTagihan)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const Ditanggung = ({ classes, formData }) => {
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}> Ditanggung </p>
      <table width={"100%"} className={classes.tableTagihan}>
        <tbody>
          <tr>
            <td width={"60%"}>Ditanggung</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.ditanggung?.ditanggung)}
            </td>
          </tr>
          <tr>
            <td width={"60%"}>Total Tagihan</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.ditanggung?.total_tagihan)}
            </td>
          </tr>
          <tr>
            <td
              colSpan={3}
              style={{
                padding: "0.8rem 0",
              }}
            ></td>
          </tr>

          {formData.is_paket ? (
            <>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "0.8rem 0",
                  }}
                ></td>
              </tr>
            </>
          ) : (
            <></>
          )}
          <tr>
            <td></td>
            <td
              colSpan={2}
              style={{
                borderBottom: "1px dashed black",
                padding: "0.5rem 0",
              }}
            ></td>
          </tr>

          <tr>
            <td width={"60%"}>Selisih Ditanggung</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formData.ditanggung.jumlah_selisih < 0
                ? `(${formatNumber(
                    Math.abs(formData.ditanggung.jumlah_selisih),
                  )})`
                : `${formatNumber(formData.ditanggung.jumlah_selisih)}`}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const TotalPaket = ({ classes, formData }) => {
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}> Total Paket </p>
      <table width={"100%"} className={classes.tableTagihan}>
        <tbody>
          <tr>
            <td width={"60%"}>Total Paket</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.totalPaket?.total_paket)}
            </td>
          </tr>
          <tr>
            <td width={"60%"}>Total Tagihan</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.totalPaket?.total_tagihan)}
            </td>
          </tr>
          <tr>
            <td
              colSpan={3}
              style={{
                padding: "0.8rem 0",
              }}
            ></td>
          </tr>

          <tr>
            <td></td>
            <td
              colSpan={2}
              style={{
                borderBottom: "1px dashed black",
                padding: "0.5rem 0",
              }}
            ></td>
          </tr>
          <tr>
            <td width={"60%"}>Selisih Paket</td>
            <td width={"5%"}>Rp.</td>
            <td align="right">
              {formatNumber(formData.totalPaket?.jumlah_selisih)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default TabTagihan
